import { createPageReader } from '../createPageReader.jsx';
export default createPageReader('WAAS', 'about');
